import { render, staticRenderFns } from "./baseHeader.vue?vue&type=template&id=132f99fa&scoped=true"
import script from "./baseHeader.vue?vue&type=script&lang=js"
export * from "./baseHeader.vue?vue&type=script&lang=js"
import style0 from "./baseHeader.vue?vue&type=style&index=0&id=132f99fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f99fa",
  null
  
)

export default component.exports